<div class="card__loader">
  <app-card-header>
    <app-card-photo></app-card-photo>
  </app-card-header>
  <app-card-main>
    <app-card-top>
      <div class="card__loader-title"></div>
      <div class="card__loader-tag"></div>
    </app-card-top>
    <app-card-bottom>
      <div class="card__loader-bottom">
        <div class="card__loader-bottom-row">
          <div class="card__loader-price"></div>
          <div class="card__loader-price card__loader-price--right"></div>
        </div>
      </div>
    </app-card-bottom>
  </app-card-main>
</div>
